import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-transferencia-ticket',
  templateUrl: './modal-transferencia-ticket.component.html',
  styleUrls: ['./modal-transferencia-ticket.component.scss']
})
export class ModalTransferenciaTicketComponent implements OnInit, OnDestroy {
  @Input() chatData;
  @Input() msgSelecionadas;
  @Input() mensagensChat;
  tipoTransferencia: any;
  fila: any;
  tecnico: any;
  observacao: string = '';
  selector: string;
  newSubs: Subscription;
  is_fila_workflow: boolean = false;
  tipo_transferencia_fila: number = 1;
  transferindo: boolean = false;
  enviaMsgs: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    public translate: TranslateService,
    private chatService: ChatService,
    private elemRef: ElementRef,
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  changeTecnico(event) {
    this.tecnico = event;
  }

  changeFila(event) {
    this.fila = event;
    this.is_fila_workflow = event.is_fila_workflow;
    this.tipo_transferencia_fila = 1;
  }

  verificaTransferencia(): void {
    if(this.msgSelecionadas && this.msgSelecionadas.length && this.tipo_transferencia_fila === 2) {
      Swal.fire({
        text: this.translate.instant('AVISO_TRANSFERENCIA_MSGS_PARA_WORKFLOW'),
        icon: 'warning',
        confirmButtonText: this.translate.instant('SIM'),
        showCancelButton: true,
        cancelButtonText: this.translate.instant('NAO')
      }).then(result => {
        if(result.isConfirmed) {
          this.transferirChat();
        }
      })
    } else {
      this.transferirChat();
    }
  }

  transferirChat(): void {
    this.transferindo = true;
    let params = {
      observacao_tranferencia: this.observacao
    };

    if(this.tipo_transferencia_fila === 1) {
      if(this.enviaMsgs) {
        params['messages_id'] = this.mensagensChat;
      } else if(this.msgSelecionadas) {
        params['messages_id'] = this.msgSelecionadas;
      }
    }

    if (this.tipoTransferencia === 1) {
      params['fila_id'] = this.fila.id;

      if(this.is_fila_workflow) {
        params['fluxo_manual'] = this.tipo_transferencia_fila === 1 ? true : false;
        params['observacao_tranferencia'] = this.tipo_transferencia_fila === 2 ? '' : params['observacao_tranferencia'];
      }
      
      this.newSubs = this.chatService.transferirFilas(params, this.chatData._id)
        .subscribe({
          next: (res) => {
            this.toastr.show(this.translate.instant('TRANSFERIDO_SUCESSO'), "", environment.toastrConfig("success"));
            this.close({"status":"ok"});
          }, error: (error) => {
            this.transferindo = false;
          }
      });
    } else {
      params['tecnico_id'] = Number(this.tecnico.id.split('-')[0]);
      params['fila_id'] = Number(this.tecnico.id.split('-')[1]);
      this.newSubs = this.chatService.transferirTecnico(params, this.chatData._id)
        .subscribe({
          next: (res) => {
            this.toastr.show(this.translate.instant('TRANSFERIDO_SUCESSO'), "", environment.toastrConfig("success"));
            this.close({"status":"ok"});
          }, error: (error) => {
            this.transferindo = false;
          }
      });
    }
  }

  close(result?) {
    this.activeModal.close(result);
  }

}
